import { useSyncExternalStore } from 'react'

import {
  isMockingSuspended,
  subscribeToImpersonationGuard,
} from './engine/impersonationGuard'
import { isScenarioActive } from './scenario'
import { readScenario } from './store/scenarioStore'

// Scenario changes force a full reload (see MocktailConfigDialog), so the localStorage half of
// this is a plain synchronous read — no live subscription needed for it. Impersonation can
// suspend mocking mid-session with no reload, though, so that half must be checked live.
export function isMocktailActive(): boolean {
  return isScenarioActive(readScenario()) && !isMockingSuspended()
}

// For UI (the "Mocked" ribbon) that must stop showing the instant mocking is suspended, rather
// than waiting for some unrelated re-render to happen to pick up the new value.
export function useIsMocktailActive(): boolean {
  return useSyncExternalStore(subscribeToImpersonationGuard, isMocktailActive)
}
